import React from 'react';

const PasswordUpdateSuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop with whitish blur */}
      <div 
        className="absolute inset-0 bg-white/40 backdrop-blur-md"
        onClick={onClose}
      />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl border-[1.5px] border-primary-blue shadow-2xl w-full max-w-[20rem] 2xl:max-w-[22rem]">
        {/* Header - optional, can be removed for cleaner look */}
        <div className="relative px-8 pt-6 pb-3">
          <button
            onClick={onClose}
            className="absolute right-6 top-6 hover:opacity-70 transition-opacity"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
              <path d="M8 8L16 16M16 8L8 16" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Icon and Message */}
        <div className="px-8 pb-6 pt-2 flex flex-col items-center">
         <div className="mb-4">
            <img
              src="/Icons/Tick.svg"
              alt="2-Factor Authentication"
              className="w-20 h-20"
            />
          </div>
          
          {/* Success Title */}
          <h3 className="text-lg text-center text-gray-900 mb-2">
            Your Password Has Been Updated Successfully
          </h3>
        </div>

        {/* Action Button */}
        <div className="px-12 pb-6 pt-2">
          <button
            onClick={onClose}
            className="w-full py-3 bg-primary-blue text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors text-base"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordUpdateSuccessModal;
